"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeInaccessibleCustomerInvoiceDetailsRows = exports.composeInvoiceDetailsRows = exports.composeACHBody = exports.composeInvoiceConfirmationRows = exports.composeCustomerDetailsHeader = exports.composeCustomerConfirmationHeader = exports.composeInaccessibleCustomerDetailsHeader = exports.createFooter = exports.createHeaderACH = exports.createPaymentDetailsHeaderTable = exports.createPaymentConfirmationHeaderTable = exports.createPaymentActivityHeaderTable = exports.createAllInvoicesHeaderTable = exports.createHeader = exports.createDoc = void 0;
const usfoods_logo_print_1 = require("../../constants/usfoods-logo-print");
const jspdf_1 = require("jspdf");
require("jspdf-autotable");
const jspdf_autotable_1 = require("jspdf-autotable");
const payments_pdf_generation_1 = require("../../constants/payments-pdf-generation");
const transform_data_1 = require("./transform-data");
const createDoc = (fileName, orientation = "p") => {
    const doc = new jspdf_1.default({ orientation, unit: "px" });
    doc.setProperties({ title: fileName });
    doc.setFont("Helvetica");
    doc.setTextColor(payments_pdf_generation_1.PAYMENTS_BLACK);
    return doc;
};
exports.createDoc = createDoc;
const createHeader = async (doc, title, customMethod, logo = usfoods_logo_print_1.logoBase64) => {
    const endingPageNumber = doc.getCurrentPageInfo().pageNumber;
    for (let i = 0; i <= endingPageNumber; i++) {
        doc.setPage(i);
        const pageSize = doc.internal.pageSize;
        doc.addImage(logo, 20, 15, 37, 36);
        doc.setFontSize(16);
        doc.setFont("Helvetica", "bold");
        doc.text(title, 75, 23);
        doc.setFontSize(10);
        doc.setFont("Helvetica");
        customMethod();
        let topMargin = 70;
        topMargin = title === "PAYMENT DETAILS" ? 80 : 70;
        doc.setDrawColor(payments_pdf_generation_1.PAYMENTS_LIGHT_GRAY);
        doc.setLineWidth(0.5);
        doc.line(0, topMargin, pageSize.getWidth(), topMargin);
    }
    return doc;
};
exports.createHeader = createHeader;
const createAllInvoicesHeaderTable = (doc, dateLabel) => {
    const body = [
        [
            { content: "Date Range:", styles: { fontStyle: "bold" } },
            { content: dateLabel, colSpan: 2 },
        ],
    ];
    (0, jspdf_autotable_1.default)(doc, {
        body,
        startY: 30,
        margin: { left: 70 },
        theme: "plain",
        tableWidth: "wrap",
        columnStyles: {
            0: { cellWidth: 42 },
            1: { cellWidth: 200 },
        },
        styles: { fontSize: 8, textColor: payments_pdf_generation_1.PAYMENTS_BLACK, valign: "middle" },
    });
};
exports.createAllInvoicesHeaderTable = createAllInvoicesHeaderTable;
const createPaymentActivityHeaderTable = (doc, dateLabel) => {
    const body = [
        [
            { content: "Date Range:", styles: { fontStyle: "bold" } },
            { content: dateLabel, colSpan: 2 },
        ],
    ];
    (0, jspdf_autotable_1.default)(doc, {
        body,
        startY: 30,
        margin: { left: 70 },
        theme: "plain",
        tableWidth: "wrap",
        columnStyles: {
            0: { cellWidth: 42 },
            1: { cellWidth: 200 },
        },
        styles: { fontSize: 8, textColor: payments_pdf_generation_1.PAYMENTS_BLACK },
    });
};
exports.createPaymentActivityHeaderTable = createPaymentActivityHeaderTable;
const createPaymentConfirmationHeaderTable = (doc, paymentSummary) => {
    const body = [
        [
            { content: "Payment Date:", styles: { fontStyle: "bold" } },
            { content: paymentSummary.paymentDate, colSpan: 2 },
            { content: "Status:", styles: { fontStyle: "bold" } },
            { content: paymentSummary.status, colSpan: 2 },
            { content: "Total Amount:", styles: { fontStyle: "bold" } },
            transform_data_1.TransformData.numberToUSDString(paymentSummary.totalAmount),
        ],
        [
            {
                content: "Number of Customers:",
                colSpan: 2,
                styles: { fontStyle: "bold" },
            },
            paymentSummary.customerAmount,
            {
                content: "Number of Transactions:",
                colSpan: 2,
                styles: { fontStyle: "bold" },
            },
            paymentSummary.transactionAmount,
            "",
            "",
        ],
    ];
    (0, jspdf_autotable_1.default)(doc, {
        body,
        startY: 30,
        margin: {
            left: 70,
        },
        theme: "plain",
        tableWidth: "wrap",
        columnStyles: {
            0: { cellWidth: 50 },
            1: { cellWidth: 23 },
            2: { cellWidth: 43 },
            3: { cellWidth: 28 },
            4: { cellWidth: 50 },
            5: { cellWidth: 43 },
            6: { cellWidth: 50 },
            7: { cellWidth: 50 },
        },
        styles: { fontSize: 8, textColor: payments_pdf_generation_1.PAYMENTS_BLACK },
    });
};
exports.createPaymentConfirmationHeaderTable = createPaymentConfirmationHeaderTable;
const createPaymentDetailsHeaderTable = (doc, paymentActivity, processedDate) => {
    const styles = {
        cellPadding: 0,
        fontSize: 8,
        textColor: payments_pdf_generation_1.PAYMENTS_BLACK,
    };
    const firstBody = [
        [
            {
                content: "Reference Number:",
                styles: { fontStyle: "bold" },
                rowSpan: 1,
            },
            { content: paymentActivity.referenceNumber, rowSpan: 5 },
        ],
    ];
    const secondBody = [
        [
            { content: "Number of Items:", styles: { fontStyle: "bold" } },
            { content: paymentActivity.itemCount },
            { content: "Number of Customers:", styles: { fontStyle: "bold" } },
            { content: paymentActivity.customerCount },
            { content: "Payment Method:", styles: { fontStyle: "bold" } },
            payments_pdf_generation_1.PaymentMethodEnum[paymentActivity.paymentMethod],
        ],
    ];
    const thirdBody = [
        [
            { content: "Processed:", styles: { fontStyle: "bold" } },
            { content: processedDate },
            { content: "Total Amount:", styles: { fontStyle: "bold" } },
            transform_data_1.TransformData.numberToUSDString(paymentActivity.totalPaymentAmount),
        ],
    ];
    (0, jspdf_autotable_1.default)(doc, {
        body: firstBody,
        startY: 30,
        margin: {
            left: 76,
        },
        theme: "plain",
        tableWidth: "wrap",
        columnStyles: {
            0: { cellWidth: 60 },
            1: { cellWidth: 240 },
        },
        styles,
    });
    (0, jspdf_autotable_1.default)(doc, {
        body: secondBody,
        startY: 45,
        margin: {
            left: 76,
        },
        theme: "plain",
        tableWidth: "wrap",
        columnStyles: {
            0: { cellWidth: 52 },
            1: { cellWidth: 48 },
            2: { cellWidth: 67 },
            3: { cellWidth: 33 },
            4: { cellWidth: 55 },
            5: { cellWidth: 45 },
        },
        styles,
    });
    (0, jspdf_autotable_1.default)(doc, {
        body: thirdBody,
        startY: 60,
        margin: {
            left: 76,
        },
        theme: "plain",
        tableWidth: "wrap",
        columnStyles: {
            0: { cellWidth: 36 },
            1: { cellWidth: 64 },
            2: { cellWidth: 43 },
            3: { cellWidth: 57 },
        },
        styles,
    });
};
exports.createPaymentDetailsHeaderTable = createPaymentDetailsHeaderTable;
const createHeaderACH = async (doc, title, logo = usfoods_logo_print_1.logoBase64) => {
    const endingPageNumber = doc.getCurrentPageInfo().pageNumber;
    for (let i = 0; i <= endingPageNumber; i++) {
        doc.setPage(i);
        const pageSize = doc.internal.pageSize;
        doc.addImage(logo, 20, 15, 37, 36);
        doc.setFontSize(16);
        doc.setFont("Helvetica", "bold");
        doc.text(title, 75, 40);
        doc.setFontSize(10);
        doc.setFont("Helvetica");
        let topMargin = 70;
        topMargin = title === "PAYMENT DETAILS" ? 80 : 70;
        doc.setDrawColor(payments_pdf_generation_1.PAYMENTS_LIGHT_GRAY);
        doc.setLineWidth(0.5);
        doc.line(0, topMargin, pageSize.getWidth(), topMargin);
    }
    return doc;
};
exports.createHeaderACH = createHeaderACH;
const createFooter = (doc) => {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        doc.line(0, pageHeight - 22, pageSize.getWidth(), pageHeight - 22);
        doc.setFontSize(7);
        doc.text("For the exclusive use by US Foods customers", 13, pageHeight - 10);
        const printDate = new Date();
        doc.text(`Print Date: ${printDate
            .toLocaleDateString("en-US")
            .toString()}  |  Page ${i} of ${pageCount}`, doc.internal.pageSize.getWidth() - 100, pageHeight - 10);
    }
    return doc;
};
exports.createFooter = createFooter;
const composeInaccessibleCustomerDetailsHeader = () => {
    const titleStylesInaccessibleCustomer = {
        fillColor: payments_pdf_generation_1.PAYMENTS_GREY,
        halign: "left",
        textColor: payments_pdf_generation_1.PAYMENTS_WHITE,
    };
    const inaccesibleCustomerDetailsHeader = [
        [
            {
                content: "For reference Only",
                colSpan: 1,
                styles: {
                    ...titleStylesInaccessibleCustomer,
                    ...{
                        cellWidth: 420,
                    },
                },
            },
        ],
    ];
    return inaccesibleCustomerDetailsHeader;
};
exports.composeInaccessibleCustomerDetailsHeader = composeInaccessibleCustomerDetailsHeader;
const composeCustomerConfirmationHeader = (customer) => {
    const custTotal = customer.transactions.reduce((acc, transaction) => {
        return acc + transaction.paymentAmount;
    }, 0);
    const customerHeaderTitle = `${transform_data_1.TransformData.capitalizeFirstLetterOfEachWord(customer.customerName)} #${customer.customerNumber}      ${transform_data_1.TransformData.capitalizeFirstLetterOfEachWord(customer.selectedBankAccount?.bankName)} ****${customer.selectedBankAccount?.last4AccountNumber}      Cust. total: ${transform_data_1.TransformData.numberToUSDString(custTotal)}`;
    return [
        [
            {
                content: customerHeaderTitle,
                colSpan: 7,
                styles: {
                    fillColor: false,
                    halign: "left",
                    lineColor: payments_pdf_generation_1.PAYMENTS_LIGHT_GRAY,
                    lineWidth: 0.2,
                    textColor: payments_pdf_generation_1.PAYMENTS_BLACK,
                    fontSize: 8,
                },
            },
        ],
        [
            { content: "Transaction" },
            { content: "Customer PO" },
            { content: "Order Number" },
            { content: "Date Issued" },
            { content: "Amount" },
            { content: "Amount Due" },
            { content: "Due Date" },
            { content: "Payment Amount" },
        ],
    ];
};
exports.composeCustomerConfirmationHeader = composeCustomerConfirmationHeader;
const composeCustomerDetailsHeader = (paymentDetail) => {
    const titleStyles = {
        fillColor: false,
        halign: "left",
        textColor: payments_pdf_generation_1.PAYMENTS_BLACK,
        fontSize: 8,
    };
    const customerHeaderTitle = `${paymentDetail.customerName} #${paymentDetail.customerNumber}      Customer total: ${transform_data_1.TransformData.numberToUSDString(paymentDetail.paymentAmount)}`;
    const accessWarning = paymentDetail.userHasAccessToCust ? "" : "";
    const detailsHeader = [
        [
            {
                content: customerHeaderTitle,
                colSpan: 2,
                styles: {
                    ...titleStyles,
                    ...{
                        cellWidth: 140,
                    },
                },
            },
            {
                content: accessWarning,
                styles: {
                    ...titleStyles,
                    ...{
                        halign: "right",
                    },
                },
            },
        ],
    ];
    if (paymentDetail.userHasAccessToCust) {
        detailsHeader.push([
            {
                content: "Transaction",
                styles: { halign: "left" },
            },
            {
                content: "Document Date",
            },
            { content: "Amount" },
        ]);
    }
    return detailsHeader;
};
exports.composeCustomerDetailsHeader = composeCustomerDetailsHeader;
const composeInvoiceConfirmationRows = (customer) => {
    return customer.transactions.map((t) => {
        const transactionName = transform_data_1.TransformData.formatTransactionName(t);
        return [
            transactionName,
            t.customerPO ? t.customerPO : "",
            t.orderNumber ? t.orderNumber + "" : "",
            transform_data_1.TransformData.formatDateCustom(t.issueDate),
            transform_data_1.TransformData.numberToUSDString(t.amount),
            transform_data_1.TransformData.numberToUSDString(t.amountDue),
            transform_data_1.TransformData.formatDateCustom(t.dueDate),
            transform_data_1.TransformData.numberToUSDString(t.paymentAmount),
        ];
    });
};
exports.composeInvoiceConfirmationRows = composeInvoiceConfirmationRows;
const composeACHBody = (doc, achForm) => {
    const styles = {
        cellPadding: 1,
        fontSize: 10,
        textColor: payments_pdf_generation_1.PAYMENTS_BLACK,
    };
    const pageSize = doc.internal.pageSize;
    const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
    const linePadding = 10;
    const columnLength = (pageSize.getWidth() - 76) / 2;
    const lineStartX = 76;
    const lineEndX = pageSize.getWidth() - 55;
    const firstBody = [
        [
            {
                content: "Customer Authorization Agreement for ACH Debit Direct Payments",
                styles: { fontStyle: "bold" },
                colSpan: 1,
            },
        ],
        [
            {
                content: payments_pdf_generation_1.ACH_AGREEMENT_TEXT_1,
                colSpan: 1,
            },
        ],
        [
            {
                content: payments_pdf_generation_1.ACH_AGREEMENT_TEXT_2,
                colSpan: 1,
            },
        ],
        [
            {
                content: payments_pdf_generation_1.ACH_AGREEMENT_TEXT_3,
                colSpan: 1,
            },
        ],
    ];
    const secondBody = [
        [
            { content: `Address: ${achForm.address1}`, colSpan: 1 },
            { content: `Phone Number: ${achForm.telephoneNumber}`, colSpan: 1 },
        ],
        [
            { content: `City: ${achForm.city}`, colSpan: 1 },
            { content: `State: ${achForm.state}`, colSpan: 1 },
        ],
        [{ content: `Zip Code: ${achForm.zip}`, colSpan: 1 }],
    ];
    const thirdBody = [
        [
            { content: `Print Name: ${achForm.signature}`, colSpan: 1 },
            { content: `Date: ${achForm.signedDate}`, colSpan: 1 },
        ],
    ];
    const fourthBody = [
        [
            {
                content: "Account Information",
                styles: { fontStyle: "bold" },
                colSpan: 2,
            },
        ],
        [
            {
                content: `Customer: ${achForm.customerName} #${achForm.customerNumber}`,
                colSpan: 1,
            },
        ],
        [{ content: `Bank Name: ${achForm.bankName}`, colSpan: 1 }],
        [{ content: `Account Number: ${achForm.accountNumber}`, colSpan: 1 }],
        [{ content: `Nickname: ${achForm.nickName}`, colSpan: 1 }],
        [{ content: `Effective Date: ${achForm.effectiveDate}`, colSpan: 1 }],
        [{ content: "Payment(s) made on: Due Date", colSpan: 1 }],
        [{ content: `Email on file: ${achForm.email}`, colSpan: 1 }],
    ];
    (0, jspdf_autotable_1.default)(doc, {
        body: firstBody,
        startY: doc.previousAutoTable.finalY ?? 85,
        margin: {
            left: 76,
        },
        theme: "plain",
        tableWidth: "wrap",
        columnStyles: {
            0: { cellWidth: pageSize.getWidth() - 140 },
        },
        styles: {
            cellPadding: 2,
            fontSize: 10,
            textColor: payments_pdf_generation_1.PAYMENTS_BLACK,
        },
    });
    const lineFirstBody = doc.lastAutoTable.finalY || 85;
    doc.line(lineStartX, lineFirstBody + 5, lineEndX, lineFirstBody + 5);
    const secondBodyStart = doc.previousAutoTable.finalY ?? 85;
    (0, jspdf_autotable_1.default)(doc, {
        body: secondBody,
        startY: secondBodyStart + linePadding,
        margin: {
            left: 76,
        },
        theme: "plain",
        tableWidth: "auto",
        columnStyles: {
            0: { cellWidth: columnLength },
            1: { cellWidth: "auto" },
        },
        styles,
    });
    const lineSecondBody = doc.lastAutoTable.finalY || 85;
    doc.line(lineStartX, lineSecondBody + 5, lineEndX, lineSecondBody + 5);
    const thirdBodyStart = doc.previousAutoTable.finalY ?? 85;
    (0, jspdf_autotable_1.default)(doc, {
        body: thirdBody,
        startY: thirdBodyStart + linePadding,
        margin: {
            left: 76,
        },
        theme: "plain",
        tableWidth: "auto",
        columnStyles: {
            0: { cellWidth: columnLength },
            1: { cellWidth: "auto" },
        },
        styles,
    });
    const lineThirdBody = doc.lastAutoTable.finalY || 85;
    doc.line(lineStartX, lineThirdBody + 5, lineEndX, lineThirdBody + 5);
    const fourthBodyStart = doc.previousAutoTable.finalY ?? 85;
    (0, jspdf_autotable_1.default)(doc, {
        body: fourthBody,
        startY: fourthBodyStart + linePadding,
        margin: {
            left: 76,
        },
        theme: "plain",
        tableWidth: "wrap",
        columnStyles: {
            0: { cellWidth: "auto" },
        },
        styles,
    });
    doc.setFontSize(9);
    doc.text("If you have any questions or changes regarding Autopay details, please call 1-800-214-6262.", 76, pageHeight - 30);
};
exports.composeACHBody = composeACHBody;
const composeInvoiceDetailsRows = (detail) => {
    return detail.invoices?.map((transaction) => {
        const hasSecondaryTransaction = transform_data_1.TransformData.isValidTransactionNumber(transaction?.secondaryTransaction) &&
            transform_data_1.TransformData.isValidTransactionNumber(transaction?.originalTransaction);
        const transactionName = transaction.transactionDescription +
            " #: " +
            `${transaction.originalTransaction !== "0" &&
                !!transaction.originalTransaction
                ? transaction.originalTransaction
                : transaction.secondaryTransaction}` +
            `${hasSecondaryTransaction
                ? " - Invoice #: " + transaction.originalTransaction
                : ""}`;
        const date = transform_data_1.TransformData.convertDate(transaction.issueDate);
        const styles = {
            lineColor: payments_pdf_generation_1.PAYMENTS_GREY,
            lineWidth: 0.2,
            fontSize: 8,
            fontStyle: "normal",
        };
        return [
            {
                content: transactionName,
                styles: {
                    ...styles,
                    ...{ halign: "left" },
                },
            },
            {
                content: date ? transform_data_1.TransformData.formatDateCustom(date) : "",
                styles,
            },
            {
                content: transform_data_1.TransformData.numberToUSDString(transaction.payAmount),
                styles,
            },
        ];
    });
};
exports.composeInvoiceDetailsRows = composeInvoiceDetailsRows;
const composeInaccessibleCustomerInvoiceDetailsRows = (detail) => {
    const inaccessibleCustomerTitle = `${detail.customerName} #${detail.customerNumber}      Customer total: ${transform_data_1.TransformData.numberToUSDString(detail.paymentAmount)}`;
    const styles = {
        lineColor: payments_pdf_generation_1.PAYMENTS_GREY,
        lineWidth: 0.2,
    };
    return [
        [
            {
                content: inaccessibleCustomerTitle,
                styles: {
                    ...styles,
                    ...{ halign: "left" },
                },
            },
        ],
    ];
};
exports.composeInaccessibleCustomerInvoiceDetailsRows = composeInaccessibleCustomerInvoiceDetailsRows;
